var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Hide hint",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L21 21",
    stroke: "#4c7d9f",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 10.6C10.23 10.97 10 11.46 10 12C10 13.1 10.9 14 12 14C12.54 14 13.03 13.77 13.4 13.4",
    stroke: "#4c7d9f",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4 7.73C5.46 8.72 4.02 10.3 3.15 12C4.83 15.28 8.15 17.5 12 17.5C13.45 17.5 14.82 17.18 16.05 16.61",
    stroke: "#4c7d9f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 14.32C20.16 13.78 20.55 13 20.85 12C19.17 8.72 15.85 6.5 12 6.5C11.36 6.5 10.73 6.56 10.12 6.68",
    stroke: "#4c7d9f",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ab69e639c4e0ea3281004d3a90cd42f1.svg";
export { ForwardRef as ReactComponent };